/* eslint-disable @typescript-eslint/naming-convention */
'use client';

import { Accordion } from '@gds/Accordion/Accordion';
import { Typography } from '@gds/Typography/Typography';

import type { ReservationFaqContent } from '../../../Entities/FaqContent.entity';

import styles from './ReserveNowFaq.module.css';

interface ReserveNowFaqProps {
  faqContent: ReservationFaqContent;
  title: string;
}

export const ReserveNowFaq = ({ faqContent, title }: ReserveNowFaqProps) => {
  const { faqItem } = faqContent;

  return (
    <div className={styles.modalWrapper}>
      <div className={styles.title}>
        <Typography variant="h4" className={styles.title}>
          {title}
        </Typography>
      </div>
      {faqItem?.map(faq => {
        const { accordionItemTitle, accordionItemContent } = faq;

        return (
          <Accordion key={accordionItemTitle} title={accordionItemTitle}>
            <div
              className={styles.description}
              dangerouslySetInnerHTML={{ __html: accordionItemContent || '' }}
            />
          </Accordion>
        );
      })}
    </div>
  );
};
